import { EmptyState } from "@/components/molecules";

export const ArchivedExternalSuppliersEmptyState = ({ hasFilters }: { hasFilters?: boolean; }) => {
  return (
    <EmptyState 
      title="Manage External Suppliers" 
      description={hasFilters ? "There are no external suppliers matching your filter criteria at the moment." : "It looks like you haven't added any external suppliers yet. Begin by adding your first external supplier to get started"} 
    />
  );
};